module.exports = __webpack_public_path__ + "img/classic.ba7656a.jpg";